import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquisortable',
	templateUrl:'./JQUISortablePluginCompPage.html',
	styles: [],
	styleUrls:['./JQUISortablePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUISortablePluginCompPage
{
	mdContent_1024 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.sortable.JQUISortable;
\`\`\``;
	mdContent_1025 = `\`\`\`java
JQUISortable()
\`\`\``;
	mdContent_1026 = `\`\`\`java
JQUISortable&lt;?&gt; sortable = new JQUISortable&lt;&gt;();
sortable.add(new ListItem&lt;&gt;("Item 1"));
sortable.add(new ListItem&lt;&gt;("Item 2"));
sortable.add(new ListItem&lt;&gt;("Item 3"));
sortable.getOptions().setPlaceholder("ui-state-highlight");
\`\`\``;
}
